import { useState } from "react";
import { Button, Flex, Separator } from "@radix-ui/themes";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Settings2 } from "lucide-react";
import { ExploreDisplayOptionsProps } from "./ExploreDisplayOptions.model";
import { useExploreDisplayOptions } from "./useExploreDisplayOptions";
import { GroupingSection } from "./GroupingSection";
import { OrderingSection } from "./OrderingSection";
import { DisplayColumnsSection } from "./DisplayColumnsSection";
import { AggregationColumnsSection } from "./AggregationColumnsSection";

export function ExploreDisplayOptions({
  value,
  onChange,
  source,
  selectedColumns,
}: ExploreDisplayOptionsProps) {
  const [isOpen, setIsOpen] = useState(false);

  const {
    availableGroupByOptions,
    availableColumns,
    availableOrderByColumns,
    availableAggColumns,
    selectedAggColumns,
    activeSorting,
    groupByLabel,
    orderByLabel,
    handleGroupByChange,
    handleOrderByChange,
    handleOrderDirToggle,
    handleColumnToggle,
    handleAggColumnToggle,
  } = useExploreDisplayOptions({ value, onChange, source });

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger>
        <Button variant="outline" size="2">
          <Settings2 className="size-4" />
          Display
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-80" align="end">
        <div className="flex flex-col">
          <div className="px-2 py-1">
            <GroupingSection
              groupByLabel={groupByLabel}
              currentGroupBy={value.groupBy}
              availableOptions={availableGroupByOptions}
              onGroupByChange={handleGroupByChange}
            />
          </div>

          <DropdownMenuSeparator />

          <div className="px-2 py-1">
            <OrderingSection
              orderByLabel={orderByLabel ?? ""}
              activeOrderBy={activeSorting.orderBy ?? undefined}
              activeOrderDir={activeSorting.orderDir ?? undefined}
              availableOptions={availableOrderByColumns}
              onOrderByChange={handleOrderByChange}
              onOrderDirToggle={handleOrderDirToggle}
            />
          </div>

          {!value.groupBy && (
            <>
              <DropdownMenuSeparator />
              <div className="px-2 py-1">
                <DisplayColumnsSection
                  availableColumns={availableColumns}
                  selectedColumns={selectedColumns}
                  onColumnToggle={handleColumnToggle}
                />
              </div>
            </>
          )}

          {value.groupBy && (
            <>
              <DropdownMenuSeparator />
              <div className="px-2 py-1">
                <AggregationColumnsSection
                  availableColumns={availableAggColumns}
                  selectedColumns={selectedAggColumns}
                  onColumnToggle={handleAggColumnToggle}
                />
              </div>
            </>
          )}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
